import Commons from "../../../Services/Common/Common";

export const M_RNM_BASIC_03_Schema = {
  fields: {
    resultContent: { initial: '', label: '조치 결과', required: 'Y' },
    resultDate: { initial: '', label: '조치일', required: 'Y' },
  },

  mapper: {
    save1: {
      NearMissSeq: (row) => row.nearMissSeq || null,
      CustCd: (row) => Commons.EncryptAES(row.custCd ?? ''),
      Gubun: (row) => Commons.EncryptAES(row.gubun || ''),
      GongjongCd: (row) => Commons.EncryptAES(row.gongjongCd || ''),
      OccurDate: (row) => Commons.EncryptAES(row.occurDate || ''),
      Location: (row) => Commons.EncryptAES(row.location || ''),
      Content: (row) => Commons.EncryptAES(row.content || ''),
      TodaySafety: (row) => Commons.EncryptAES(row.todaySafety || ''),
      ReductionMeasures: (row) => Commons.EncryptAES(row.reductionMeasures || ''),
      ResultContent: (row) => Commons.EncryptAES(row.resultContent || ''),
      ResultDate: (row) => Commons.EncryptAES(row.resultDate || ''),
      ManagerId: (_, context) => context.userInfo?.userid ?? '',
      Status: (row) => Commons.EncryptAES('1' || ''),
      Remark: (row) => Commons.EncryptAES('' || ''),
      UserId: (_, context) => context.userInfo?.userid ?? '',
      Images: (row) => row.images || [],
    },
  },
};